import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./OtpStyles.css";
import "./CustomerFormStyle.css";
import { onecodeAPI } from "../AppConfig";
import { Checkbox, Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import { useSearchParams } from "react-router-dom";
import { isNumber } from "../utils/regexConstants";
import _ from "lodash";

const ConsentOTP = ({ customerName, customerPhoneNum }) => {
  const [otp, setOtp] = useState(new Array(4).fill(""));
  const [invalidOTP, setInvalidOTP] = useState(false);
  const [counter, setCounter] = React.useState(120);
  const [timeLeft, setTimeLeft] = useState(0);
  const [loading, setLoading] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();
  const [reloading, setReloading] = useState(false);
  const [clickResend, setClickResend] = useState(0);
  const [lockedTill, setLockedTill] = useState({});
  const [agree, setAgree] = useState(false);
  const [customerId, setCustomerId] = useState(null);

  const antIcon = (
    <LoadingOutlined style={{ fontSize: 24, color: "white" }} spin />
  );

  //sendOtp
  const sendConsentOtp = async () => {
    try {
      let hash = encodeURIComponent(searchParams.get("hash"));
      const res = await onecodeAPI.post(
        `public/customer/addCustomerOtp?bureauReportConsent=true`,
        {
          fullName: customerName,
          phoneNumber: customerPhoneNum,
          hash: hash,
        }
      );
      setSearchParams({ hash: decodeURIComponent(res.data.hash) });
      let customerID = res?.data?.customerId;
      setCustomerId(customerID);
      const object = {
        locktill: res.data.lockedTill,
        reason: res.data.reason,
      };
      setLockedTill(object);
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };

  useEffect(() => {
    if (customerName && customerPhoneNum) sendConsentOtp();
  }, [customerName, customerPhoneNum]);

  //Resend OTP
  const addCustomer = async () => {
    setClickResend(clickResend + 1);
    window?.Moengage?.track_event(
      "customer-profile_reconsent_customer_otp_resend"
    );
    try {
      setReloading(true);
      setOtp(new Array(4).fill(""));
      setInvalidOTP(false);
      let hash = encodeURIComponent(searchParams.get("hash"));
      const res = await onecodeAPI.post(
        `public/customer/addCustomerOtp?bureauReportConsent=true`,
        {
          fullName: customerName,
          phoneNumber: customerPhoneNum,
          hash: hash,
        }
      );
      let locked = _.get(res, "data.lockedTill");
      let reaso = _.get(res, "data.reason");
      let customerID = res?.data?.customerId;
      setCustomerId(customerID);
      const object = {
        locktill: locked,
        reason: reaso,
      };
      setLockedTill(object);
      setCounter(120);
      setReloading(false);
    } catch (error) {
      setReloading(false);
      console.log("error-otp", error);
    }
  };

  // Verifying OTP
  function handleClick() {
    if (otp.join("").trim().length < 4) {
      setInvalidOTP(true);
    } else {
      setLoading(true);
      let hash = encodeURIComponent(searchParams.get("hash"));
      onecodeAPI
        .post(`public/customer/verifyOtp?bureauReportConsent=true`, {
          name: customerName,
          otp: otp.join("").trim(),
          phoneNumber: customerPhoneNum,
          hash: hash,
          customerId: customerId || 0,
        })
        .then(({ data }) => {
          if (data === "otp Verified") {
            window?.Moengage?.track_event(
              "customer-profile_reconsent_customer_otp_verify"
            );
            navigate(`/customer/recommendations`, {
              state: {
                hash: searchParams.get("hash"),
              },
            });
          }
          if(data == "otp not verified"){
            setInvalidOTP(true);
          }
          setLoading(false);
        })
        .catch((err) => {
          setLoading(false);
          console.log(err, "err");
          alert("Something went wrong");
        });
    }
  }

  // Timer Details
  function TimeFormat(duration) {
    //  minutes and seconds
    var mins = Math.floor((duration % 3600) / 60);
    let secs = Math.floor(duration % 60);

    let remainTime = "";
    if (mins > 0) remainTime += "" + mins + " min " + (secs < 10 ? "0" : "");
    remainTime += "" + secs + (secs === 1 ? " second" : " seconds");

    return remainTime;
  }

  useEffect(() => {
    const timer =
      counter > 0 && setInterval(() => setCounter(counter - 1), 1000);
    setTimeLeft(TimeFormat(counter));
    return () => clearInterval(timer);
  }, [counter]);

  const handleChange = (element, index) => {
    // enableButton(element.target.value);

    if (isNaN(element.value)) return false;
    if (!isNumber.test(element.value)) return false;

    setOtp([...otp.map((d, idx) => (idx === index ? element.value : d))]);
    setInvalidOTP(false);

    //Focus next input
    if (element.nextSibling) {
      element.nextSibling.focus();
    }
  };
  const navigate = useNavigate();

  function onChange(e) {
    setAgree(!agree);
  }

  return (
    <div>
      <div className="row">
        <div
          className="name"
          style={{
            marginTop: "60px",
          }}
        >
          <p>{`OTP sent on +91 ${customerPhoneNum} via SMS`}</p>
          {counter > 0 && !lockedTill?.locktill ? (
            <p className="expire">Expires in {timeLeft}</p>
          ) : !lockedTill?.locktill ? (
            <div>
              <button onClick={addCustomer} type="submit" className="resend">
                {reloading && <Spin indicator={antIcon} />}
                Resend OTP
              </button>
            </div>
          ) : (
            <></>
          )}
        </div>
        <div className="otp-box">
          {otp.map((data, index) => {
            return (
              <input
                className="otp-field"
                type="number"
                name="otp"
                maxLength="1"
                key={index}
                value={data}
                onChange={(e) => handleChange(e.target, index)}
                onFocus={(e) => e.target.select()}
              />
            );
          })}
        </div>
        {invalidOTP && <div className="invalidOtp">Invalid OTP</div>}

        {clickResend > 3 ? (
          <div>
            <p className="lockedTillReason">{lockedTill.reason}</p>
            <p className="lockedTillTime">{lockedTill.locktill}</p>
          </div>
        ) : null}
        {lockedTill && (
          <div>
            <p className="lockedTillReason">{lockedTill.reason}</p>
            <p className="lockedTillTime">{lockedTill.locktill}</p>
          </div>
        )}

        <div className="checkBox">
          <Checkbox
            checked={agree}
            onClick={() => {
              window?.Moengage?.track_event(
                "lf4_termsofuseprivacypolicy_check"
              );
            }}
            onChange={onChange}
            style={{ fontSize: "12px", color: "#8C8C8C" }}
          >
            Agree{" "}
            <a
              onClick={() => {
                window?.Moengage?.track_event("lf4_termsofuse_click");
              }}
              href="https://onecode-asset.s3.ap-south-1.amazonaws.com/Web+site-T%26C-Policies/EndUsersEULA-OneCode.html"
              style={{ color: "#6C63FF", fontWeight: "500px" }}
            >
              Terms of use
            </a>{" "}
            &
            <a
              onClick={() => {
                window?.Moengage?.track_event("lf4_privacypolicy_click");
              }}
              href="https://onecode-asset.s3.ap-south-1.amazonaws.com/Web+site-T%26C-Policies/EndUsersPrivacyPolicy-OneCode+.html"
              style={{ color: "#6C63FF", fontWeight: "500px" }}
            >
              {" "}
              Privacy Policy
            </a>
          </Checkbox>
        </div>

        <div className="verify-btn">
          <button
            type="submit"
            className="verify"
            onClick={handleClick}
            disabled={!agree}
          >
            {loading && <Spin indicator={antIcon} />}
            Give Consent
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConsentOTP;
